import React from 'react';
import HeroBannerVisID from '@hpi-sox/hpstellar-core/visId/HeroBanner';
import withPageComponents from '../../../page/components/with-page-components';
import { extractCommonProperties } from '../../../utility/setHtml';
import './hero-banner.less';

const heroBanner = ({ categoryHeroBanner }) => {
    if ((categoryHeroBanner || []).length < 1) return null;

    const { slides, commonProperties } = extractCommonProperties(categoryHeroBanner);
    return <HeroBannerVisID className="visIdCategoryHeroBanner" slides={slides} {...commonProperties} />;
};

export default withPageComponents(heroBanner, { components: ['categoryHeroBanner'] });
